export default "__VITE_ASSET__c66cef32__"